import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export default function BoothDetail() {
  const [booth, setBooth] = useState(null);
  const [branch, setBranch] = useState(null);
  const { boothID } = useParams('');
  const [services, setServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [slots, setSlots] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedSlotIDs, setSelectedSlotIDs] = useState([]); // State to track selected slots
  const [errorMessage, setErrorMessage] = useState(''); // State to manage error messages
  const navigate = useNavigate();const handleDateChange = (date) => {
    // Create a new Date object based on the selected date, adjusted to avoid timezone issues.
    const adjustedDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    setSelectedDate(adjustedDate);
  };
  
 
  

  useEffect(() => {
    const fetchBooth = async () => {
      try {
        const response = await axios.get(`https://fboothapi.azurewebsites.net/api/booth/${boothID}`);
        setBooth(response.data);
        console.log(response.data)
        const branchResponse = await axios.get(`https://fboothapi.azurewebsites.net/api/branch/${response.data.branchID}`);
        setBranch(branchResponse.data);
      } catch (error) {
        console.error('Error fetching booth data:', error);
      }
    };

    const fetchServices = async () => {
      try {
        const response = await axios.get('https://fboothapi.azurewebsites.net/api/service/customer');
        setServices(response.data.map(service => ({ ...service, quantity: 0 })));
      } catch (error) {
        console.error('Error fetching services:', error);
      }
    };

    fetchBooth();
    fetchServices();
  }, [boothID]);

  useEffect(() => {
    if (boothID && selectedDate) {
      fetchSlots();
    }
  }, [boothID, selectedDate]);

  const fetchSlots = async () => {
    const formattedDate = selectedDate.toISOString().split('T')[0].replace(/-/g, '/');
    try {
      const response = await axios.get(`https://fboothapi.azurewebsites.net/api/slot/booth?boothID=${boothID}&date=${formattedDate}&ticks=0`);
      setSlots(response.data);
    } catch (error) {
      console.error('Error fetching slots:', error);
    }
  };

  const handleSlotClick = (slotID, slotIndex) => {
    if (selectedSlotIDs.includes(slotID)) {
      // Deselect the slot if it's already selected
      setSelectedSlotIDs(selectedSlotIDs.filter(id => id !== slotID));
      setErrorMessage(''); // Clear error message when deselecting
    } else {
      const newSelectedSlots = [...selectedSlotIDs, slotID];
      const selectedIndices = newSelectedSlots.map(id => slots.findIndex(slot => slot.slotID === id)).sort((a, b) => a - b);

      // Check if selected slots are continuous and time is contiguous
      let isValid = true;
      for (let i = 1; i < selectedIndices.length; i++) {
        const prevSlot = slots[selectedIndices[i - 1]];
        const currentSlot = slots[selectedIndices[i]];

        // Compare the end time of the previous slot with the start time of the current slot
        const prevEndTime = new Date(`${selectedDate.toISOString().split('T')[0]}T${prevSlot.slotEndTime}`);
        const currentStartTime = new Date(`${selectedDate.toISOString().split('T')[0]}T${currentSlot.slotStartTime}`);

        if (selectedIndices[i] !== selectedIndices[i - 1] + 1 || currentStartTime.getTime() !== prevEndTime.getTime()) {
          isValid = false;
          break;
        }
      }

      if (isValid) {
        setSelectedSlotIDs(newSelectedSlots);
        setErrorMessage('');
      } else {
        setErrorMessage('Please select consecutive slots with adjacent times.');
      }
    }
  };

  const handleIncrement = (serviceID) => {
    setServices((prevServices) =>
      prevServices.map((service) =>
        service.serviceID === serviceID ? { ...service, quantity: service.quantity + 1 } : service
      )
    );
  };

  const handleDecrement = (serviceID) => {
    setServices((prevServices) =>
      prevServices.map((service) =>
        service.serviceID === serviceID && service.quantity > 0 ? { ...service, quantity: service.quantity - 1 } : service
      )
    );
  };

  const handleAddService = (service) => {
    if (service.quantity > 0) {
      const updatedServices = [...selectedServices];
      const existingService = updatedServices.find(item => item.serviceID === service.serviceID);
      if (existingService) {
        existingService.quantity += service.quantity;
      } else {
        updatedServices.push({ ...service });
      }
      setSelectedServices(updatedServices);
      // Reset service quantity after adding
      setServices((prevServices) =>
        prevServices.map((s) =>
          s.serviceID === service.serviceID ? { ...s, quantity: 0 } : s
        )
      );
    }
  };

  const handleRemoveService = (serviceID) => {
    const updatedServices = selectedServices.filter(service => service.serviceID !== serviceID);
    setSelectedServices(updatedServices);
  };

  const handleBooking = async () => {
    const user = JSON.parse(sessionStorage.getItem('user')); // Assume user object contains tokenID
    const tokenID = sessionStorage.getItem('userToken'); // Retrieve tokenID from session storage

    if (!user || !tokenID) {
      setErrorMessage("You need to sign in to book.");
      return;
    }

    if (selectedSlotIDs.length === 0) {
      setErrorMessage("Please select at least one slot to book.");
      return;
    }

    const slotTimes = selectedSlotIDs.map(slotID => {
      const slot = slots.find(s => s.slotID === slotID);
      return { startTime: slot.slotStartTime, endTime: slot.slotEndTime };
    });

    const startTime = slotTimes[0].startTime;
    const endTime = slotTimes[slotTimes.length - 1].endTime;

    const bookingData = {
      boothID: boothID,
      serviceList: selectedServices.reduce((acc, service) => {
        acc[service.serviceID] = service.quantity;
        return acc;
      }, {}),
      date: selectedDate.toISOString().split('T')[0], // Format date as YYYY-MM-DD
      startTime: startTime, // Pass startTime in "hh:mm" format
      endTime: endTime,     // Pass endTime in "hh:mm" format
    };

    console.log("Booking Data:", bookingData); // Debugging output

    try {
      const response = await axios.post('https://fboothapi.azurewebsites.net/api/booking/customer-booking', bookingData, {
        headers: {
          Authorization: `Bearer ${tokenID}`, // Include the token in the Authorization header
        }
      });
      console.log('Booking successful:', response.data);
      sessionStorage.setItem('bookingData', JSON.stringify(response.data));
      navigate('/payment');
      setErrorMessage('');
      // Navigate to confirmation page or show success message
    } catch (error) {
      console.error('Error during booking:', error);

      if (error.response && error.response.data && error.response.data.title) {
        // Show detailed error messages from the server
        const serverErrors = error.response.data.title;
        setErrorMessage(`Booking failed: ${serverErrors}`);
      } else {
        setErrorMessage('Booking failed. Please try again.');
      }
    }
  };

  if (!booth) {
    return <p>Loading...</p>;
  }

  return (
    <div className="container mx-auto py-8 bg-white">
      {/* Back Button */}
      <button 
  onClick={() => navigate(-1)}
  className="mb-4 text-blue-500 hover:text-blue-700"
>
  ← Back 
</button>


<div className="flex gap-8 mb-8">
  {/* Booth Photos */}
  <div className="w-full md:w-1/2">
    <div className="mb-4">
      <img 
       className="w-[600px] h-[500px] rounded object-cover"
        src={booth.boothPhotos[0]?.boothPhotoUrl || 'https://via.placeholder.com/300x300'} 
        alt="Main Booth"
        
      />
    </div>
    <div className="grid grid-cols-4 gap-4">
      {booth.boothPhotos.slice(1, 5).map((photo, index) => (
        <div key={index}>
          <img 
            className="h-40 w-full rounded-lg object-cover" 
            src={photo.boothPhotoUrl || 'https://via.placeholder.com/150x150'} 
            alt={`Booth ${index + 1}`}
          />
        </div>
      ))}
    </div>
  </div>

  {/* Booth Overview */}
  <div className="w-full md:w-3/5 p-8 bg-white rounded-lg shadow-lg">
  <h2 className="text-4xl font-extrabold text-gray-900 mb-6">{booth.boothName}</h2>
  
  <h3 className="text-2xl font-bold text-gray-800 mb-4">Overview</h3>
  <div className="space-y-6">
    <div className="flex items-center">
      <span className="font-bold text-gray-600 w-1/4 flex items-center">
        <svg className="w-5 h-5 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 3a1 1 0 01.993.883L11 4v12a1 1 0 01-1.993.117L9 16V4a1 1 0 011-1z" />
          <path d="M6.293 7.293a1 1 0 011.414 0L10 9.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" />
        </svg>
        Concept:
      </span>
      <span className="ml-2 text-gray-800">{booth.concept}</span>
    </div>
    <div className="flex items-center">
      <span className="font-bold text-gray-600 w-1/4 flex items-center">
        <svg className="w-5 h-5 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5z" />
        </svg>
        Background:
      </span>
      <span className="ml-2 text-gray-800">{booth.backgroundColor}</span>
    </div>
    <div className="flex items-center">
      <span className="font-bold text-gray-600 w-1/4 flex items-center">
        <svg className="w-5 h-5 text-yellow-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 18a8 8 0 100-16 8 8 0 000 16zM9 7a1 1 0 112 0v4a1 1 0 11-2 0V7zm0 6a1 1 0 112 0 1 1 0 01-2 0z" />
        </svg>
        People in Booth:
      </span>
      <span className="ml-2 text-gray-800">{booth.peopleInBooth}</span>
    </div>

    <hr className="border-t-2 border-gray-300 my-4"/>

    <h3 className="text-2xl font-bold text-gray-800 mb-4">Branch Information</h3>
    <div className="space-y-4">
      <div className="flex items-center">
        <span className="font-bold text-gray-600 w-1/4 flex items-center">
          <svg className="w-5 h-5 text-indigo-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 2a4 4 0 100 8h4a4 4 0 100-8H8zM4 9.002V17h12V9.002c.4.007.8.007 1.2 0A5 5 0 119 4c-.4.006-.8.006-1.2 0H4zM8 10a2 2 0 110 4 2 2 0 010-4z" />
          </svg>
          Branch Name:
        </span>
        <span className="ml-2 text-gray-800">{branch?.branchName}</span>
      </div>
      <div className="flex items-center">
        <span className="font-bold text-gray-600 w-1/4 flex items-center">
          <svg className="w-5 h-5 text-teal-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 2a1 1 0 01.993.883L11 3v2h7a1 1 0 011 .993v9.014a1 1 0 01-.883.993L18 16h-1v2a1 1 0 01-.883.993L16 19h-5.072a6.96 6.96 0 01-1.732-2H16v-4h-6a1 1 0 01-.993-.883L9 12V4a1 1 0 01.883-.993L10 3h4a1 1 0 01.993.883L15 4v1h1.292l-4.646-4.646a.5.5 0 00-.708.708L15.293 5H10V4a1 1 0 01.883-.993L11 3H4a1 1 0 01-.993-.883L3 2a1 1 0 01.883-.993L4 1h6zM3 6a1 1 0 011 .993v1.014a1 1 0 01-.883.993L3 9H2V7.014a1 1 0 01.883-.993L3 6h1V5H3zm0 7v2h1v-2H3zm0 3v2h1v-2H3zm2-5h1V9H5v2zm0 3v2h1v-2H5zm10-7h1v1h-1V7zm0 3v2h1v-2h-1zm0 3v2h1v-2h-1z" />
          </svg>
          Address:
        </span>
        <span className="ml-2 text-gray-800">{branch?.address}, {branch?.town}, {branch?.city}</span>
      </div>
      <div className="flex items-center">
        <span className="font-bold text-gray-600 w-1/4 flex items-center">
          <svg className="w-5 h-5 text-red-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 3.293l5 5V13h2V8.293a1 1 0 00-.293-.707l-7-7A1 1 0 007 1v2H5a2 2 0 00-2 2v10a2 2 0 002 2h4v2a1 1 0 001.707.707l7-7A1 1 0 0019 10V7.414a2 2 0 00-.586-1.414l-7-7A2 2 0 009 0H4a2 2 0 00-2 2v12a2 2 0 002 2h2v-2H4a2 2 0 01-2-2V4a2 2 0 012-2h2V1a1 1 0 011-1h5z" />
          </svg>
          Status:
        </span>
        <span className="ml-2 text-gray-800">{branch?.status}</span>
      </div>
      <div className="flex items-center">
        <span className="font-bold text-gray-600 w-1/4 flex items-center">
          <svg className="w-5 h-5 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 4.5A5.5 5.5 0 0114.5 10h-1A4.5 4.5 0 009 5.5V4.5zm1 6.5a1 1 0 00-1-1H8.5a1 1 0 100 2H9a1 1 0 001-1zM4 4a2 2 0 01.91.213 4.992 4.992 0 00-1.105 1.884L3 6.7V6h1V4zM2 9.5v1h1v-1H2zm1 3v1h1v-1H3zm0 2.5v1h1v-1H3zM9 18.5V17h1v1.5a2 2 0 01-.91.213 4.992 4.992 0 001.105-1.884L10 16.7V17h-1v1.5z" />
            <path d="M6 5a1 1 0 011-1h4a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1V5z" />
            <path fillRule="evenodd" d="M4 9a1 1 0 011-1h10a1 1 0 011 1v8a1 1 0 01-1 1H5a1 1 0 01-1-1V9zm10-4a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V7a2 2 0 012-2h8z" clipRule="evenodd" />
          </svg>
          Opening Time:
        </span>
        <span className="ml-2 text-gray-800">{`${branch?.openingTime}`}</span>
      </div>
      <div className="flex items-center">
        <span className="font-bold text-gray-600 w-1/4 flex items-center">
          <svg className="w-5 h-5 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 2a1 1 0 01.993.883L11 3v2h7a1 1 0 011 .993v9.014a1 1 0 01-.883.993L18 16h-1v2a1 1 0 01-.883.993L16 19h-5.072a6.96 6.96 0 01-1.732-2H16v-4h-6a1 1 0 01-.993-.883L9 12V4a1 1 0 01.883-.993L10 3h4a1 1 0 01.993.883L15 4v1h1.292l-4.646-4.646a.5.5 0 00-.708.708L15.293 5H10V4a1 1 0 01.883-.993L11 3H4a1 1 0 01-.993-.883L3 2a1 1 0 01.883-.993L4 1h6zM3 6a1 1 0 011 .993v1.014a1 1 0 01-.883.993L3 9H2V7.014a1 1 0 01.883-.993L3 6h1V5H3zm0 7v2h1v-2H3zm0 3v2h1v-2H3zm2-5h1V9H5v2zm0 3v2h1v-2H5zm10-7h1v1h-1V7zm0 3v2h1v-2h-1zm0 3v2h1v-2h-1z" />
          </svg>
          Closing Time:
        </span>
        <span className="ml-2 text-gray-800">{`${branch?.closingTime}`}</span>
      </div>
    </div>
  </div>
</div>

</div>


      {/* Date Picker */}
      <div className="mt-8 p-6 bg-[#DEECFF] rounded-lg shadow-md">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">Select a date for your booking.</h2>
        <DatePicker
    selected={selectedDate}
    onChange={handleDateChange}
    dateFormat="yyyy/MM/dd"
    className="border p-2 rounded w-full"
  />
      </div>

      {/* Slot Booking Section */}
      <div className="mt-8 p-6 bg-[#F3F8FF] rounded-lg shadow-md">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">Choose your desired slots</h2>
        <div className="grid grid-cols-8 gap-2">
          {slots
            .filter(slot => {
              // Create a Date object for the slot's time
              const slotDateTime = new Date(`${selectedDate.toISOString().split('T')[0]}T${slot.slotStartTime}`);
              // Only include slots that are in the future
              return slotDateTime > new Date();
            })
            .map((slot, index) => (
              <div
                key={slot.slotID}
                className={`p-4 rounded-lg text-center border-2 ${
                  slot.status === 'Available' 
                    ? selectedSlotIDs.includes(slot.slotID)
                      ? 'border-blue-500 bg-blue-100 text-black' 
                      : 'border-blue-500 bg-white text-black'
                    : 'bg-[#FCC8D1] text-[#FCC8D1]-500 border-[#FCC8D1]-300'
                }`}
                style={{
                  cursor: slot.status === 'Available' ? 'pointer' : 'not-allowed',
                }}
                onClick={() => slot.status === 'Available' && handleSlotClick(slot.slotID, index)}
              >
                <p className='font-bold'>{slot.slotStartTime} - {slot.slotEndTime}</p>
                <p className='text-sm'>{slot.price.toLocaleString()} VND </p>
              </div>
               
            ))}
        </div>
        {errorMessage && (
          <p className="text-red-500 mt-4">{errorMessage}</p>
        )}
      </div>

      {/* Services Section */}
      <div className="mt-8 p-6 rounded-lg">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">Choose your desired services</h2>
        <table className="min-w-full bg-white border rounded-lg">
          <thead>
            <tr>
              <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-sm leading-4 text-gray-700 tracking-wider">Service</th>
              <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-sm leading-4 text-gray-700 tracking-wider">Price</th>
              <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-sm leading-4 text-gray-700 tracking-wider">Quantity</th>
              <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-sm leading-4 text-gray-700 tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody>
            {services.map((service, index) => (
              <tr key={index}>
                <td className="px-6 py-4 border-b border-gray-300 text-gray-800">{service.serviceName}</td>
                <td className="px-6 py-4 border-b border-gray-300 text-gray-800">{service.servicePrice.toLocaleString()} VND</td>
                <td className="px-6 py-4 border-b border-gray-300 text-gray-800">
                  <div className="flex items-center">
                    <button
                      onClick={() => handleDecrement(service.serviceID)}
                      className="bg-gray-300 px-2 rounded"
                    >
                      -
                    </button>
                    <span className="mx-2">{service.quantity}</span>
                    <button
                      onClick={() => handleIncrement(service.serviceID)}
                      className="bg-gray-300 px-2 rounded"
                    >
                      +
                    </button>
                  </div>
                </td>
                <td className="px-6 py-4 border-b border-gray-300 text-gray-800">
                  <button
                    onClick={() => handleAddService(service)}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700"
                  >
                    Add Service
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Selected Services Section */}
      <div className="mt-8 p-6 rounded-lg">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">Selected Services</h2>
        {selectedServices.length > 0 ? (
          <ul>
            {selectedServices.map((service, index) => (
              <li key={index} className="flex justify-between items-center bg-gray-100 p-4 rounded mb-4">
                <div>
                  <p className="text-lg font-semibold">{service.serviceName}</p>
                  <p className="text-gray-600">Quantity: {service.quantity}</p>
                </div>
                <button
                  onClick={() => handleRemoveService(service.serviceID)}
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-700"
                >
                  Remove Service
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <p>No services added yet.</p>
        )}
      </div>

      <button 
        onClick={handleBooking}
        className="mt-8 bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600"
      >
        Book It
      </button>
    </div>
  );
}
